<script>
	import {state} from '@sock/state'
	import {server, connected} from '@sock/connection'
</script>

{#if $connected}
<h2>{$server}</h2>

<pre>
{JSON.stringify($state, null, 2)}
</pre>
{:else}
<h2>Not connected</h2>
{/if}

<style>
pre {
	width: 100%;
	overflow: auto;
	background: var(--white);
}
</style>
